module.exports = __webpack_public_path__ + "media/images/icons/flags/VG-bb9ceb1d836286660181ff0eb389f780.svg";